import Repository from './Repository'

const resource = 'exercises'

export default {
  getExercises (lessonId, params) {
    return Repository.get(`lessons/${lessonId}/${resource}`, { params: params })
  }
}
